import React from 'react'
import NewProductsBanner from '../../../react4xp/components/NewProductsBanner'

function NewProductsBannerPart({ productsBanner, bgColor, heading }) {
    return (
        <>
            <NewProductsBanner
                sectionTitle={heading}
                section={{bgColor}}
                howMany={productsBanner.length}
                products={productsBanner.map(productBanner => {
                    return {
                        href: productBanner.url?.href,
                        external: productBanner.isExternal,
                        src: productBanner.image?.link,
                        alt: productBanner.image?.alt,
                        srcMobile: productBanner.image?.link,
                        tilt: productBanner.tilt,
                        hoverTilt: productBanner.hoverTilt,
                        title: productBanner.title,
                        desc: productBanner.intro
                    }
                })}
            />
        </>
    )
  }

export default (props) => <NewProductsBannerPart {...props} />
